import React from "react";
import { Select, InputNumber, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Product } from "../../../Types";

const { Option } = Select;

interface Props {
  products: Product[];
  isProductsLoading: boolean;
  selectedProductId: string | null;
  selectedProduct: Product | null;
  selectedStockId: string | null;
  transferQty: number;
  onProductSearch: (v: string) => void;
  onProductChange: (id: string) => void;
  onStockChange: (id: string) => void;
  onQtyChange: (qty: number) => void;
  onAdd: () => void;
}

export const TransferItemPicker: React.FC<Props> = ({
  products,
  isProductsLoading,
  selectedProductId,
  selectedProduct,
  selectedStockId,
  transferQty,
  onProductSearch,
  onProductChange,
  onStockChange,
  onQtyChange,
  onAdd,
}) => {
  console.log(selectedProduct);

  return (
    <div className="bg-gray-50 border border-gray-100 rounded-md p-3 flex flex-col gap-3">
      <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
        Add Product Stock
      </div>

      <Select
        showSearch
        placeholder="Search product in source store"
        filterOption={false}
        onSearch={onProductSearch}
        onChange={(val) => onProductChange(val)}
        value={selectedProductId}
        notFoundContent={null}
        loading={isProductsLoading}
      >
        {products.map((p) => (
          <Option key={p.id} value={p.id}>
            <span className="font-medium">{p.title}</span>
            <span className="ml-1.5 text-xs text-gray-400">{p.sku_code}</span>
          </Option>
        ))}
      </Select>

      {selectedProductId && (
        <div className="grid grid-cols-3 gap-2 items-end">
          <div className="col-span-2">
            <label className="text-xs text-gray-500 mb-1 block">
              Stock Batch
            </label>
            <Select
              placeholder="Select batch"
              onChange={onStockChange}
              value={selectedStockId}
              className="w-full"
            >
              {selectedProduct?.stocks?.map((s) => (
                <Option key={s.id} value={s.id}>
                  {s.batch_no} (Avail: {s.quantity} {selectedProduct.unit})
                </Option>
              ))}
            </Select>
          </div>

          <div>
            <label className="text-xs text-gray-500 mb-1 block">Quantity</label>
            <InputNumber
              min={1}
              value={transferQty}
              onChange={(val) => onQtyChange(val || 1)}
              className="w-full"
            />
          </div>
        </div>
      )}

      <div className="flex justify-end">
        <Button
          type="dashed"
          icon={<PlusOutlined />}
          onClick={onAdd}
          disabled={!selectedProductId || !selectedStockId}
        >
          Add Item
        </Button>
      </div>
    </div>
  );
};
